import(/* webpackMode: "eager" */ "/Users/juancartagena/foundry/neotral/node_modules/.pnpm/next@14.2.21_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
